<template>
<div class="chapter">
<div class="inner_page">
<p class="aut" style="margin-top: 10em;">Also by Lisa Doan</p>
<p class="aut1">The Berenson Schemes #1:<br/>Jack the Castaway</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?7677811c